import React, { useState, useEffect } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	Typography,
	Box,
	DialogActions,
	Divider,
	IconButton,
	Stack,
} from '@mui/material';
import {
	getHarassmentTendencies,
	getSuicidalTendencies,
	clearHarassmentTendencies,
	clearSuicidalTendencies,
	setHarassmentTendencies,
	setSuicidalTendencies,
	setDismissTimestamp,
	isDismissedRecently,
	clearDismissTimestamp,
} from '../Utils/storage/criticalRecords';
import { CloseIcon, InfoOutlineIcon } from './Icons/Icons';
import { useLocation } from 'react-router-dom';
import { AppColors } from '../Utils/helper/AppColors';
import UserThumbnail from './User/UserThumbnail';
import CultService from '../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../Utils/helper/HelperTexts';
const CriticalInfoModal = () => {
	const [typeQueue, setTypeQueue] = useState([]);
	const [currentType, setCurrentType] = useState('');
	const [records, setRecords] = useState([]);
	const [open, setOpen] = useState(false);
	const location = useLocation();

	useEffect(() => {
		const harassment = getHarassmentTendencies() || [];
		const suicidal = getSuicidalTendencies() || [];

		const queue = [];

		if (harassment?.length > 0 && !isDismissedRecently()) {
			queue.push('harassment');
		}
		if (suicidal?.length > 0 && !isDismissedRecently()) {
			queue.push('suicidal');
		}

		if (queue?.length > 0) {
			setTypeQueue(queue);
			setCurrentType(queue[0]);
			setOpen(true);
			loadRecords(queue[0]);
		}
	}, [location]);

	const loadRecords = (type) => {
		const data = type === 'harassment' ? getHarassmentTendencies() : getSuicidalTendencies();
		if(data && Array.isArray(data)){
			data.reverse(); 
		}
		setRecords(data);
	};

	const handleResolve = async (id) => {
		// call api to resolve the record
		// await resolveRecord(id);
		// toast.success('Record resolved successfully');

		try {
			let res = await CultService.acknowledgeCriticalRecord({ data: { compaignUserId: id } });

			// not needed to show error toast will remove
			if (!res?.status) {
				toast.error(res?.data?.message);
				return;
			}

			if (res?.status) {
				toast.success(res?.data?.message || 'Record resolved successfully');
			}

			const updated = records.filter((r) => r?.id !== id);

			// update records in localStorage
			if (currentType === 'harassment') {
				setHarassmentTendencies(updated);
				if (updated?.length === 0) {
					clearHarassmentTendencies();
					// clearDismissTimestamp();
				}
			} else {
				setSuicidalTendencies(updated);
				if (updated?.length === 0) {
					clearSuicidalTendencies();
					// clearDismissTimestamp();
				}
			}

			// set updated records and continue
			if (updated?.length === 0) {
				showNextModal();
			} else {
				setRecords(updated);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
		}
	};

	const handleCancel = () => {
		// store dismiss timestamp
		setDismissTimestamp();
		showNextModal();
	};

	const showNextModal = () => {
		const nextQueue = [...typeQueue];
		nextQueue?.shift();
		if (nextQueue?.length > 0) {
			const nextType = nextQueue[0];
			setTypeQueue(nextQueue);
			setCurrentType(nextType);
			loadRecords(nextType);
			setOpen(true);
		} else {
			setOpen(false);
		}
	};

	if (!open || records?.length === 0) return null;

	return (
		<Dialog open={open} disableEscapeKeyDown maxWidth="lg">
			<Stack direction="row" justifyContent="space-between" paddingX={'20px'}>
				<DialogTitle
					sx={{
						display: 'flex',
						fontWeight: 'bold',
						fontSize: 20,
						// paddingTop: 4,
						backgroundColor: AppColors.WHITE,
						borderRadius: '10px',
						paddingX: '0px',
						color: AppColors?.midnight_black || AppColors.BLACK,
					}}
				>
					{/* <InfoOutlineIcon color={AppColors.TEXT_ERROR} size={70} /> */}
					{currentType === 'harassment' ? 'Harassment Records' : 'Suicidal Records'}
				</DialogTitle>

				<IconButton
					onClick={handleCancel}
					sx={{
						color: 'grey.600',
						backgroundColor: 'transparent',
						'&:hover': {
							backgroundColor: 'transparent', // No background on hover
						},
					}}
				>
					<CloseIcon size={25} />
				</IconButton>
			</Stack>
			{/* <Divider /> */}
			<DialogContent sx={{ paddingx: '20px', paddingY: '10px', backgroundColor: AppColors.WHITE }}>
				{records?.map((record) => (
					<Box
						key={record?.id}
						display="flex"
						// justifyContent="space-between"
						alignItems="center"
						gap={2}
						mb={2}
						p={2}
						borderRadius={2}
						boxShadow={1}
						// sx={{
						// 	background:
						// 		currentType === 'harassment'
						// 			? 'linear-gradient(2.39deg, #FFFFFF 2%, rgba(254, 248, 239, 0.73) 55.08%, #FFFBE7 98%)'
						// 			: 'linear-gradient(2.39deg, #FFFFFF 2%, rgba(254, 239, 239, 0.73) 55.08%, #FFE7E7 98%)',
						// }}
					>
						<Box
							sx={{
								padding: 1,
								border: '1px solid #EEEFF0',
								backgroundColor: AppColors.WHITE,
								borderRadius: '50%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<InfoOutlineIcon color={currentType === 'harassment' ? AppColors?.orange || '#E28F10' : AppColors?.tomato_orange || '#D14141'} size={30} />

							{/* 
							<Typography variant="body2" color="text.secondary">
									{record?.userId?.email}
							</Typography> */}
						</Box>
						<Stack direction="column" alignItems="start" gap={1} sx={{ minWidth: '87%' }}>
							<UserThumbnail
								TextColor={currentType === 'harassment' ? AppColors?.orange || '#E28F10' : AppColors?.tomato_orange || '#D14141'}
								userId={record?.userId?._id}
								user={record?.userId}
								type="criticalSectionUser"
							/>
							<Stack direction="row" alignItems="center" gap={1}>
								<Typography
									sx={{
										flex: 1,
										fontSize: '14px',
										lineHeight: '150%',
										fontWeight: 400,
										fontFamily: 'Poppins',
										color: AppColors.HEADING_TITLE,
									}}
								>
									{record?.summary || 'No summary available'}
								</Typography>
							</Stack>
						</Stack>
						<Button
							variant="contained"
							sx={{
								color: AppColors.WHITE,
								backgroundColor: currentType === 'harassment' ? AppColors?.orange || '#E28F10' : AppColors?.tomato_orange || '#D14141',
								'&:hover': {
									backgroundColor: currentType === 'harassment' ? AppColors?.darkOrange || '#D17F0E' : AppColors?.darkTomato || '#B33A3A', // Darker shade for hover
								},
							}}
							onClick={() => handleResolve(record?.id)}
						>
							OK
						</Button>
					</Box>
				))}
			</DialogContent>
			<Divider />
		</Dialog>
	);
};

export default CriticalInfoModal;
